import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

const s = {
  root: {
    minHeight: '100vh',
    display: 'flex',
    background: '#0d0d0d',
    fontFamily: "'DM Sans', sans-serif",
  },

  /* ── Painel esquerdo (decorativo) ── */
  panel: {
    flex: '0 0 46%',
    background: '#111',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '3rem',
    position: 'relative',
    overflow: 'hidden',
  },
  panelGrid: {
    position: 'absolute',
    inset: 0,
    opacity: 0.03,
    backgroundImage: [
      'repeating-linear-gradient(0deg,   #fff 0, #fff 1px, transparent 1px, transparent 44px)',
      'repeating-linear-gradient(90deg, #fff 0, #fff 1px, transparent 1px, transparent 44px)',
    ].join(','),
  },
  panelDiag: {
    position: 'absolute',
    bottom: '-60px',
    right: '-60px',
    width: '280px',
    height: '280px',
    border: '40px solid #f0a500',
    opacity: 0.05,
    borderRadius: '50%',
  },
  logoMark: {
    position: 'relative',
    zIndex: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '46px',
    height: '46px',
    background: '#f0a500',
    borderRadius: '6px',
  },
  logoText: {
    fontFamily: "'Bebas Neue', cursive",
    color: '#0d0d0d',
    fontSize: '19px',
    letterSpacing: '1px',
    lineHeight: 1,
  },
  brandHeading: {
    position: 'relative',
    zIndex: 1,
  },
  brandTitle: {
    fontFamily: "'Bebas Neue', cursive",
    fontSize: 'clamp(3.8rem, 5.5vw, 6.5rem)',
    lineHeight: 0.88,
    color: '#fff',
    letterSpacing: '-1px',
    margin: 0,
  },
  brandAccent: {
    color: '#f0a500',
  },
  brandSub: {
    color: '#444',
    fontSize: '0.78rem',
    marginTop: '1.5rem',
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    fontWeight: 400,
  },
  cmyk: {
    position: 'relative',
    zIndex: 1,
  },
  cmykBar: {
    display: 'flex',
    gap: '3px',
    height: '5px',
    marginBottom: '1.25rem',
  },
  cmykC: { flex: 1, background: '#00b4d8', borderRadius: '2px' },
  cmykM: { flex: 1, background: '#e040fb', borderRadius: '2px' },
  cmykY: { flex: 1, background: '#f0a500', borderRadius: '2px' },
  cmykK: { flex: 1, background: '#2a2a2a', borderRadius: '2px' },
  cmykLabel: {
    color: '#2a2a2a',
    fontSize: '0.68rem',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },

  /* ── Painel direito (formulário) ── */
  formSide: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
  },
  formWrap: {
    width: '100%',
    maxWidth: '360px',
  },
  formTitle: {
    fontFamily: "'Bebas Neue', cursive",
    fontSize: '2rem',
    color: '#fff',
    letterSpacing: '0.06em',
    margin: 0,
  },
  formSub: {
    color: '#555',
    fontSize: '0.84rem',
    marginTop: '0.4rem',
    marginBottom: '2.25rem',
  },
  fieldLabel: {
    display: 'block',
    color: '#666',
    fontSize: '0.7rem',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    marginBottom: '0.45rem',
    fontWeight: 500,
  },
  input: {
    width: '100%',
    background: '#181818',
    border: '1px solid #252525',
    borderRadius: '7px',
    padding: '0.75rem 1rem',
    color: '#e8e8e8',
    fontSize: '0.9rem',
    outline: 'none',
    transition: 'border-color 0.18s, box-shadow 0.18s',
    fontFamily: "'DM Sans', sans-serif",
  },
  fieldWrap: {
    marginBottom: '1.1rem',
  },
  errorBox: {
    background: 'rgba(224,51,51,0.08)',
    border: '1px solid rgba(224,51,51,0.22)',
    borderRadius: '7px',
    padding: '0.7rem 1rem',
    color: '#e05555',
    fontSize: '0.84rem',
    marginBottom: '1.1rem',
  },
  avisoBox: {
    background: 'rgba(240,165,0,0.08)',
    border: '1px solid rgba(240,165,0,0.22)',
    borderRadius: '7px',
    padding: '0.7rem 1rem',
    color: '#f0a500',
    fontSize: '0.84rem',
    marginBottom: '1.1rem',
  },
  btn: {
    width: '100%',
    border: 'none',
    borderRadius: '7px',
    padding: '0.9rem',
    fontFamily: "'Bebas Neue', cursive",
    fontSize: '1.15rem',
    letterSpacing: '0.12em',
    cursor: 'pointer',
    transition: 'background 0.18s, transform 0.1s',
    marginTop: '0.25rem',
  },
};

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [avisoRetry, setAvisoRetry] = useState('');
  const [carregando, setCarregando] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setErro('');
    setAvisoRetry('');
    setCarregando(true);

    for (let tentativa = 1; tentativa <= 5; tentativa++) {
      try {
        const dados = await api.login(email, senha);
        localStorage.setItem('token', dados.token);
        localStorage.setItem('usuario', JSON.stringify(dados.usuario));
        navigate('/kanban');
        return;
      } catch (err) {
        const isColdStart = err.message === 'Failed to fetch';

        if (!isColdStart || tentativa === 5) {
          setAvisoRetry('');
          setErro(isColdStart
            ? 'Servidor indisponível. Tente novamente em instantes.'
            : err.message
          );
          break;
        }

        setAvisoRetry('Servidor inicializando, aguarde...');
        await new Promise(r => setTimeout(r, 4000));
      }
    }

    setCarregando(false);
  }

  function focusInput(e)  { e.target.style.borderColor = '#f0a500'; e.target.style.boxShadow = '0 0 0 3px rgba(240,165,0,0.08)'; }
  function blurInput(e)   { e.target.style.borderColor = '#252525'; e.target.style.boxShadow = 'none'; }
  function hoverBtn(e)    { if (!carregando) { e.target.style.background = '#d9940a'; e.target.style.transform = 'translateY(-1px)'; } }
  function unhoverBtn(e)  { if (!carregando) { e.target.style.background = '#f0a500'; e.target.style.transform = 'translateY(0)'; } }

  return (
    <div style={s.root}>

      {/* ── Painel esquerdo ──────────────────── */}
      <div className="login-panel-left" style={s.panel}>
        <div style={s.panelGrid} />
        <div style={s.panelDiag} />

        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={s.logoMark}>
            <span style={s.logoText}>GM</span>
          </div>
        </div>

        <div style={s.brandHeading}>
          <h1 style={s.brandTitle}>
            GRÁFICA<br />
            <span style={s.brandAccent}>MÁXIMA</span>
          </h1>
          <p style={s.brandSub}>Sistema de rastreamento de O.S</p>
        </div>

        <div style={s.cmyk}>
          <div style={s.cmykBar}>
            <div style={s.cmykC} />
            <div style={s.cmykM} />
            <div style={s.cmykY} />
            <div style={s.cmykK} />
          </div>
          <p style={s.cmykLabel}>© 2026 Gráfica Máxima</p>
        </div>
      </div>

      {/* ── Painel direito (formulário) ──────── */}
      <div style={s.formSide}>
        <div className="login-form-animate" style={s.formWrap}>

          <h2 style={s.formTitle}>Acesso ao sistema</h2>
          <p style={s.formSub}>Entre com suas credenciais para continuar</p>

          <form onSubmit={handleSubmit}>
            <div style={s.fieldWrap}>
              <label style={s.fieldLabel}>E-mail</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="seu@email.com"
                style={s.input}
                onFocus={focusInput}
                onBlur={blurInput}
              />
            </div>

            <div style={s.fieldWrap}>
              <label style={s.fieldLabel}>Senha</label>
              <input
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
                placeholder="••••••••"
                style={s.input}
                onFocus={focusInput}
                onBlur={blurInput}
              />
            </div>

            {avisoRetry && <div style={s.avisoBox}>{avisoRetry}</div>}
            {erro && <div style={s.errorBox}>{erro}</div>}

            <button
              type="submit"
              disabled={carregando}
              style={{
                ...s.btn,
                background: carregando ? '#1e1e1e' : '#f0a500',
                color: carregando ? '#444' : '#0d0d0d',
                cursor: carregando ? 'not-allowed' : 'pointer',
              }}
              onMouseEnter={hoverBtn}
              onMouseLeave={unhoverBtn}
            >
              {carregando ? (avisoRetry ? 'AGUARDE...' : 'ENTRANDO...') : 'ENTRAR'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
